module.exports = __webpack_public_path__ + "static/media/guiaDeEstudioPrimerExamenReg2FIS3.8a595840.pdf";